import { List } from '@mui/material';
import { useMemo } from 'react';
import { getSidebarFromRoutes } from '../sidebar.utils';

const SidebarList = ({ routeConfig, onClose }) => {
  const sidebarConfig = useMemo(
    () => getSidebarFromRoutes(routeConfig),
    [routeConfig],
  );

  return (
    <List
      component="nav"
      aria-labelledby="nested-list-subheader"
      dense
      sx={{ display: 'flex', flexDirection: 'column', flex: 1, pb: 0 }}
    >
      {sidebarConfig.map((node, i) => (
        <node.component {...node} key={`${node.title}${i}`} onClose={onClose} />
      ))}
    </List>
  );
};

export default SidebarList;
